import React from 'react';
import { format } from 'date-fns';

import styles from './traceChart.scss';

export const ChartTooltip = ({ date, value }) => {
  return (
    <div className={ styles.tooltipWrapper }>
      <div className={ styles.tooltipRow }>
        <span>
          Date:
        </span>
        <span>
          { format(new Date(date), 'MMM dd, yyyy') }
        </span>
      </div>
      <div className={ styles.tooltipRow }>
        <span>
          Price:
        </span>
        <span>
          ${ value }
        </span>
      </div>
    </div>
  );
};
